module.exports = __webpack_public_path__ + "img/warning-red.c0f4c689.svg";